/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-access-state-in-setstate */
import React from 'react';
import LidarIframe from 'react-scale/components/website/index/Products/examples/LidarIframe';

import { mq } from 'react-scale/components/website/big/Themes';
import Spinner from 'react-scale/components/elements/spinner';

export default class DataAnnotation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scene: this.props.scenes[0],
      sceneActive: 0,
      annotationsByLabel: [],
      frame: this.props.scenes[0].frame,
      hideAnnotationsByLabel: []
    };
  }

  updateSelect = ev => {
    const sceneActive = parseInt(ev.target.value, 10);
    const scene = this.props.scenes[sceneActive];
    this.setState({
      sceneActive,
      scene,
      frame: scene.frame,
      annotationsByLabel: [],
      hideAnnotationsByLabel: []
    });
  };

  updateAnnotations = annotations => {
    const annotationsByLabel = annotations.map(annotationsByFrame =>
      annotationsByFrame.cuboids.reduce((acc, cuboid) => {
        if (acc[cuboid.label]) {
          acc[cuboid.label].count += 1;
        } else {
          acc[cuboid.label] = { count: 1, color: cuboid.color };
        }
        return acc;
      }, {})
    );

    this.setState({ annotationsByLabel });
  };

  updateFrame = frame => {
    this.setState({ frame });
  };

  updateHideAnnotationsByLabel = label => {
    if (this.state.hideAnnotationsByLabel.includes(label)) {
      this.setState({
        hideAnnotationsByLabel: this.state.hideAnnotationsByLabel.filter(
          labelItem => labelItem !== label
        )
      });
    } else {
      this.setState({
        hideAnnotationsByLabel: [...this.state.hideAnnotationsByLabel, label]
      });
    }
  };

  render() {
    const { activeItemColor } = this.props;
    const { scene, annotationsByLabel, frame } = this.state;
    const annotationItems = annotationsByLabel[frame] && Object.keys(annotationsByLabel[frame]);
    return (
      <section id="data-annotation">
        <article>
          {this.props.children}
          <div className="lidar">
            <div className="left-column">
              <div className="select-wrapper">
                <div className="select-info">
                  <span>{scene.title}</span>
                  <svg width="8" height="16" viewBox="0 0 8 16" fill="none">
                    <path
                      d="M0.646447 3.51008C0.451184 3.70535 0.451184 4.02193 0.646447 4.21719C0.841709 4.41245 1.15829 4.41245 1.35355 4.21719L0.646447 3.51008ZM3.86364 1L4.21719 0.646447C4.02193 0.451184 3.70535 0.451184 3.51008 0.646447L3.86364 1ZM6.37372 4.21719C6.56898 4.41245 6.88556 4.41245 7.08083 4.21719C7.27609 4.02193 7.27609 3.70535 7.08083 3.51008L6.37372 4.21719ZM1.35355 11.7828C1.15829 11.5875 0.841709 11.5875 0.646447 11.7828C0.451184 11.9781 0.451184 12.2947 0.646447 12.4899L1.35355 11.7828ZM3.86364 15L3.51008 15.3536C3.70535 15.5488 4.02193 15.5488 4.21719 15.3536L3.86364 15ZM7.08083 12.4899C7.27609 12.2947 7.27609 11.9781 7.08083 11.7828C6.88556 11.5875 6.56898 11.5875 6.37372 11.7828L7.08083 12.4899ZM1.35355 4.21719L4.21719 1.35355L3.51008 0.646447L0.646447 3.51008L1.35355 4.21719ZM3.51008 1.35355L6.37372 4.21719L7.08083 3.51008L4.21719 0.646447L3.51008 1.35355ZM0.646447 12.4899L3.51008 15.3536L4.21719 14.6464L1.35355 11.7828L0.646447 12.4899ZM4.21719 15.3536L7.08083 12.4899L6.37372 11.7828L3.51008 14.6464L4.21719 15.3536Z"
                      fill="#404040"
                    />
                  </svg>
                </div>
                <select onChange={this.updateSelect} value={this.state.sceneActive}>
                  {this.props.scenes.map((sceneItem, i) => (
                    <option key={sceneItem.title} value={i}>
                      {sceneItem.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="scenes-overflow">
                {(!annotationItems || annotationItems.length === 0) && <Spinner />}
                {annotationItems && annotationItems.length > 0 && (
                  <ul>
                    {annotationItems.map(label => (
                      <AnnotationItem
                        id={annotationsByLabel[frame][label].count}
                        name={label}
                        color={annotationsByLabel[frame][label].color}
                        key={label}
                        onClick={() => {
                          this.updateHideAnnotationsByLabel(label);
                        }}
                        itemHoverColor={activeItemColor}
                        disabled={this.state.hideAnnotationsByLabel.includes(label)}
                      />
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className="iframe-wrapper">
              <LidarIframe
                zoid
                title={scene.title}
                frames={scene.frames}
                annotations={scene.annotations}
                showImages={scene.showImages}
                frame={scene.frame}
                updateAnnotations={this.updateAnnotations}
                updateFrame={this.updateFrame}
                hideAnnotationsByLabel={this.state.hideAnnotationsByLabel}
              />
            </div>
          </div>
        </article>
        <style jsx>{`
          .lidar {
            background: transparent;
            margin: 4rem 0 0;
            padding: 0;
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: calc(4rem / 2);
            position: relative;
            z-index: 3;
            overflow: hidden;
          }
          @media (min-width: ${mq.lg}) {
            .lidar {
              grid-template-columns: 390px 1fr;
            }
          }
          .lidar .left-column {
            display: flex;
            flex-direction: column;
          }
          @media (min-width: ${mq.lg}) {
            .lidar .left-column {
              overflow: hidden;
              height: 952px;
            }
          }
          .lidar .scenes-overflow {
            background: #ffffff;
            height: 100%;
            overflow: hidden;
          }
          .lidar ul {
            height: 260px;
            margin: 0;
            padding: 0;
            list-style: none;
            overflow: scroll;
          }
          @media (min-width: ${mq.lg}) {
            .lidar ul {
              height: 100%;
            }
          }
          .lidar .iframe-wrapper {
            width: 100%;
            height: 512px;
            position: relative;
            overflow: hidden;
          }
          @media (min-width: ${mq.md}) {
            .lidar .iframe-wrapper {
              height: 952px;
            }
          }
          .lidar .select-info {
            background: ${activeItemColor};
            height: 80px;
            padding: 0 calc(4rem / 2);
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          @media (min-width: ${mq.md}) {
            .lidar .select-info {
              font-size: 1.6rem;
            }
          }
          .lidar .select-grid {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          @media (min-width: ${mq.lg}) {
            .lidar .select-grid {
              display: none;
            }
          }
          .lidar .select-wrapper {
            position: relative;
            margin: 0 0 calc(4rem / 2);
          }
          .lidar .select-wrapper select {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            z-index: 2;
            cursor: pointer;
          }
        `}</style>
      </section>
    );
  }
}

const AnnotationItem = ({ id, name, color, onClick, disabled, itemHoverColor }) => (
  <li onClick={onClick}>
    <svg viewBox="0 0 33 35">
      <rect x="0.98584" y="0.470703" width="31.9618" height="33.5423" fill={color} />
      {!disabled && (
        <g clipPath="url(#clip0)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.97516 16.7408C9.40365 15.8414 10.2606 14.7181 11.7595 15.1677C13.0449 15.6174 13.9012 16.9656 14.5437 18.7643C19.6839 12.6953 23.9672 8.42509 29.1076 7.07617C29.7503 7.07617 29.9645 7.07617 29.5361 7.52585C23.9673 11.5722 18.6129 17.6403 14.3297 25.507C14.1154 25.7319 13.9012 25.7319 13.6869 25.507C12.8299 23.2594 12.188 21.012 11.1168 18.7635C10.6883 17.6393 10.0456 16.7408 8.9751 16.7408L8.97516 16.7408Z"
            fill="black"
          />
        </g>
      )}
      <defs>
        <clipPath id="clip0">
          <rect
            width="20.7752"
            height="21.8025"
            fill="white"
            transform="translate(8.97559 5.50195)"
          />
        </clipPath>
      </defs>
    </svg>
    <div>
      <span>{name}</span>
      <span>{id} annotations</span>
    </div>
    <style jsx>{`
      li {
        color: black;
        background-color: transparent;
        height: 80px;
        padding: 0 calc(4rem / 2);
        border-bottom: 1px solid white;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        transition: all 250ms ease-out;
        cursor: pointer;
        position: relative;
      }
      @media (min-width: ${mq.lg}) {
        li {
          height: 120px;
        }
      }
      li:last-child {
        border: 0;
      }
      li:hover {
        background-color: ${itemHoverColor};
      }

      li:nth-child(7n + 1) svg rect {
        fill: #fed733;
      }

      li:nth-child(7n + 2) svg rect {
        fill: #d5abff;
      }

      li:nth-child(7n + 3) svg rect {
        fill: #fd9d52;
      }

      li:nth-child(7n + 4) svg rect {
        fill: #f792dd;
      }

      li:nth-child(7n + 5) svg rect {
        fill: #97ec4b;
      }

      li:nth-child(7n + 6) svg rect {
        fill: #50deb9;
      }

      li:nth-child(7n + 7) svg rect {
        fill: #8a9ee4;
      }

      div {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        width: 100%;
        padding: 0 0 0 calc(4rem / 2);
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      span {
        font-family: var(--font-family-code);
        font-size: 1.4rem;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      @media (min-width: ${mq.lg}) {
        span {
          font-size: 1.6rem;
        }
      }
      span:last-child {
        color: #666666;
      }

      svg {
        width: 30px;
        flex-shrink: 0;
      }
    `}</style>
  </li>
);
